import { z } from 'zod';
import {
  type Notification,
  NotificationSettingsType,
  ForumSummaryFrequency,
} from '../lib';

// Request
export const listNotificationsSchema = z
  .object({
    since: z.string().optional(),
    limit: z.string().optional(),
    offset: z.string().optional(),
  })
  .strict();

export type ListNotificationsQueryParams = z.infer<
  typeof listNotificationsSchema
>;

// Response
export interface ListNotificationsResponse {
  since: string;
  hasMore: boolean;
  notifications: Notification[];
}

/**
 * The response shape from the GET /api/notification-settings endpoint,
 * which returns the user's current settings keyed by NotificationSettingsType,
 * with 'true' meaning email notifications are enabled,
 * and 'false' meaning disabled.
 */
export interface GetNotificationSettingsResponse {
  settings: Record<NotificationSettingsType, boolean>;
  forumSummaryFrequency: ForumSummaryFrequency;
}

/**
 * The request shape for the PUT /api/notification-settings endpoint,
 * allowing the client to update notification settings for any NotificationSettingsType.
 */
export const updateNotificationSettingsBodySchema = z
  .object({
    settings: z
      .record(z.nativeEnum(NotificationSettingsType), z.boolean())
      .optional(),
    forumSummaryFrequency: z.nativeEnum(ForumSummaryFrequency).optional(),
  })
  .strict();

export type UpdateNotificationSettingsBody = z.infer<
  typeof updateNotificationSettingsBodySchema
>;

// Response
export interface UpdateNotificationSettingsResponse {
  message: string;
}
